import styled from 'styled-components';

const LocationItem = styled.li`
    padding: 12px;
`

export default LocationItem;